<template>
  <div class="dialogs">
    <!-- :close-on-click-modal='false'  是否可以通过点击 modal 关闭 Dialog   -->
    <el-dialog
      :visible.sync="data.visible"
      :width="data.size + 'px'"
      :title="data.title"
      :close="fun"
      :close-on-click-modal="closeBol.clickModal"
      :close-on-press-escape="closeBol.pressEscape"
      :show-close="closeBol.showClose"
      :before-close="fun"
    >
      <slot></slot>
      <!-- 内容 -->
      <slot name="content"></slot>
      <!-- 操作按钮 -->
      <div slot="footer">
        <slot name="btns"></slot>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["handleClose", "dialog","close"],
  data() {
    return {
      data: {
        title: "",
        size: 720,
        visible: false,
      },
      closeBol:{
        clickModal:true,
        pressEscape:true,
        showClose:true,
      },
      fun: function () {},
    };
  },
  watch: {
    dialog: {
      handler(val) {
        this.$set(this, "data", val);
      },
      immediate: true,
    },
    handleClose: {
      handler(val) {
        this.$set(this, "fun", val);
      },
      immediate: true,
    },
    close:{
      handler(val) {
        if(val){
          this.$set(this, "closeBol", val);
        }
      },
      immediate: true,
      deep:true,
    }
  },
};
</script>
<style scoped>
::v-deep .dialogs-box .el-dialog__body {
  border-top: 2px solid #f2f2f2;
}
</style>